// extracted by mini-css-extract-plugin
module.exports = {"svg":"_1yPcO6"};